// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","sub-footer":"Footer_sub-footer__ynqa+","webname":"Footer_webname__EVPbS","copyright":"Footer_copyright__JQMtz"};